<button
  *ngIf="selectedCompanyId"
  (click)="navigateToCampaignBuilder()"
  class="m-2">
  Back to Campaign builder
</button>
<div class="container terms-and-condition-page-container">
  <span [innerHTML]="getSafeHtml(termsAndConditions.html)"></span>
</div>
